<template>
    <ScrollableView class="bg-green">
        <div class="mx-auto py-8 max-w-sm text-center text-90">
            <img src="/logo.svg" style="height: 40px;" class="inline">
        </div>
        <div class="bg-white shadow rounded-lg p-8">
            <h2 class="text-2xl text-center font-normal mb-6 text-90">{{ $t("Forgot your password?") }}</h2>
            <svg class="block mx-auto mb-6" xmlns="http://www.w3.org/2000/svg" width="100" height="2" viewBox="0 0 100 2"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="08-login" fill="#D8E3EC" transform="translate(-650 -371)"><path id="Rectangle-15" d="M650 371h100v2H650z"></path></g></g></svg>
            <div v-show="linkRequested" class="text-green text-center font-semibold my-3">
                {{ $t('We have e-mailed your password reset link!') }}
            </div>
            <div v-show="errors.classifiedServerError" class="text-center font-semibold text-red my-3">
                {{ errors.classifiedServerError }}
            </div>

            <input-control v-show="!linkRequested" :label="$t('E-mail address')">
            <input
                id="email"
                v-model.trim.lazy="$v.email.$model"
                type="text"
                name="email"
                :placeholder="$t('E-mail address')"
                :class="inputClass($v.email.$anyError)"
            />
            <div v-if="$v.email.$dirty">
                <input-error :condition="!$v.email.required">
                {{ $t('The {field} field is required', { field: $t('e-mail address') }) }}
                </input-error>
                <input-error :condition="!$v.email.email">
                {{ $t('The e-mail address is not valid') }}
                </input-error>
            </div>
            </input-control>


            <button v-show="!linkRequested" class="w-full btn btn-default btn-primary bg-red" type="submit" @click.prevent="handleSubmit">
                {{ $t("Send Reset Link") }}
            </button>
        </div>
    </ScrollableView>
</template>

<script>

import { userService } from '@mobile/services/user';
import { errorHandler } from '@mobile/services/errorHandler';
import ScrollableView from '@mobile/components/ScrollableView.vue';

import {
    required, email,
} from 'vuelidate/lib/validators';
import InputControl from '../components/Form/InputControl.vue';
import InputError from '../components/Form/InputError.vue';
import { eventBus } from '@/eventBus';

export default {
    components: {
        'input-control': InputControl,
        'input-error': InputError,
        ScrollableView,
    },
    data() {
        return {
            email: '',
            errors: {
                classifiedServerError: null,
            },
            linkRequested: null,
        };
    },
    validations: {
        email: { required, email },
    },
    methods: {
        handleSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.linkRequested = null;
            this.errors.classifiedServerError = null;

            userService.requestPasswordResetLink(this.email)
                .then(() => {
                    this.linkRequested = true;
                }).catch((error) => {
                    const httpErrorMessage = errorHandler.handle(error);

                    if (httpErrorMessage === null) {
                        eventBus.$emit('error', this.$t('Connection error!'));
                        return;
                    }

                    this.errors.classifiedServerError = this.$t(httpErrorMessage);
                });
        },
        inputClass(error = false) {
            return {
                'w-full': true,
                'form-control': true,
                'form-input': true,
                'form-input-bordered': true,
                'border-red': error,
            };
        },
    },
};
</script>
